import type { ActionMessage } from 'satcheljs';
import type { CoreDatapointConfig, DatapointConfig } from 'owa-analytics-types';
import type { AnalyticsCoreEventNames, AnalyticsEventNames } from 'owa-analytics-events';
import type { MailboxInfo } from 'owa-client-types';

export default function addDatapointConfig<TMessage extends ActionMessage>(
    name: AnalyticsEventNames,
    mailbox: MailboxInfo | undefined,
    config: Omit<DatapointConfig, 'name' | 'mailbox'> | undefined,
    actionMessage: TMessage
): TMessage {
    const fullConfig: DatapointConfig = { name, mailbox, ...config };
    const messageWithDatapoint: TMessage & { dp: DatapointConfig } = {
        ...actionMessage,
        dp: fullConfig,
    };
    return messageWithDatapoint;
}

export function addCoreDatapointConfig<TMessage extends ActionMessage>(
    name: AnalyticsCoreEventNames,
    mailbox: MailboxInfo | undefined,
    config: Omit<CoreDatapointConfig, 'name' | 'mailbox'> | undefined,
    actionMessage: TMessage
): TMessage {
    const fullConfig: CoreDatapointConfig = { name, mailbox, ...config };
    if (fullConfig.options) {
        fullConfig.options.isCore = true;
    } else {
        fullConfig.options = { isCore: true };
    }
    const messageWithDatapoint: TMessage & { dp: CoreDatapointConfig } = {
        ...actionMessage,
        dp: fullConfig,
    };
    return messageWithDatapoint;
}
